<template>
    <lb-drawer
        data-testid="transaction-matching-config-new__fifo-execution-results-drawer"
        :value="dialog"
        @input="$emit('update:dialog', $event)"
        heading="FIFO Execution Results"
        width="1000"
        :loading="loading"
    >
        <template v-slot:body>
            <div>
                <div style="">
                    <div class="" v-if="results.length > 0">
                        <v-simple-table data-testid="transaction-matching-config-new__fifo-execution-table" dense class="border-on" :fixed-header="true">
                            <template v-slot:default>
                                <thead class="tableHeaderBg">
                                    <tr>
                                        <!-- Assuming results[0] has the headers -->
                                        <template v-for="(v, k) in results[0]">
                                            <th
                                                :class="{ 'active': sortColumn === k }"
                                                class="tableHeaderBg"
                                                :key="k"
                                                v-if="k !== '_id'"
                                                @click="sortBy(k)"
                                                :id="'automation-test-'+k"
                                            >
                                                {{ (k || "").replaceAll("_", " ") }}
                                                <v-icon class="ml-2" large v-if="sortColumn === k" :id="'automation-test-'+k">
                                                    {{ sortDesc ? 'mdi-menu-down' : 'mdi-menu-up' }}
                                                </v-icon>
                                            </th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(v, idx) in sortedData" :key="idx" :id="'automation-test-'+idx">
                                        <template v-for="(vv, kk) in results[0]">
                                            <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+kk">
                                                {{ typeof v[kk] === "number" ? $nova.formatNumber(v[kk].toFixed(0)) : v[kk] }}
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                    <div data-testid="transaction-matching-config-new__fifo-execution-empty-state" v-else class="text-center grey--text title pa-6">
                        No data available
                    </div>
                </div>
            </div>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'FifoExecutionResultsDrawer',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        results: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            sortColumn: '',
            sortDesc: false
        };
    },
    computed: {
        sortedData() {
            // Create a copy to avoid mutating prop if it was passed by reference (though slice does that)
            const data = this.results.slice(); // Original code used slice(1) - waiting, why slice(1)?
            // Original code: const data = this.fifoexecutionResult.slice(1);
            // If the first row is headers or something, then slice(1) is correct.
            // But line 1746 uses `fifoexecutionResult[0]` for headers.
            // If row 0 is headers, then v-for in tbody should iterate starting from 1?
            // Original code: `v-for="(v, k) in sortedData"`
            // `sortedData` computed used `this.fifoexecutionResult.slice(1)`.
            // So yes, row 0 is headers, data starts at 1.

            // Wait, if results[0] is used for TH (keys), then it is an array of objects where the first object defines keys?
            // Usually in JSON data from APIs, every object has keys.
            // Maybe the first object is metadata?
            // I will preserve the logic: slice(1).
            
            // Actually, if `fifoexecutionResult` is just data, then `slice(1)` would skip the first record.
            // Let's assume the current logic is correct for the data shape.
            
            const dataToSort = data.slice(1);

            return dataToSort.sort((a, b) => {
                const aValue = a[this.sortColumn];
                const bValue = b[this.sortColumn];

                if (typeof aValue === 'undefined' || aValue === null) return -1;
                if (typeof bValue === 'undefined' || bValue === null) return 1;

                const numA = parseFloat(aValue);
                const numB = parseFloat(bValue);

                if (!isNaN(numA) && !isNaN(numB)) {
                    return this.sortDesc ? numB - numA : numA - numB;
                } else {
                    return this.sortDesc ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
                }
            });
        }
    },
    methods: {
        sortBy(key) {
            if (this.sortColumn === key) {
                this.sortDesc = !this.sortDesc;
            } else {
                this.sortColumn = key;
                this.sortDesc = false;
            }
        }
    }
};
</script>